import { RouteConfig } from "vue-router";

export const biaScheduleRoutes: Array<RouteConfig> = [
  {
    path: "/bia-schedule",
    name: "bia-schedule",
    meta: {
      breadcrumb: [
        {
          text: "BIA Schedule",
        },
      ],
      authRequired: true,
      userTypes: ["employee", "nutritionist", "admin", "super_admin"],
    },
    component: () =>
      import(
        /* webpackChunkName: "bia-schedule" */ "../../../views/BIAScheduleView.vue"
      ),
  },
];
